import React, { useState, useEffect, useRef } from 'react';
import styles from '@styles/components/QontactPoints/TurnosV2/EditarTurno.module.css'
import { usePopup } from '@contexts/popupContext'
import { Application } from '@core/Application';
import { Loader } from '@shared/designSystem/Loader';

import {ReactComponent as QontactPointSVG} from '@assets/SVGs/QontactPoint/QontactPointSVG.svg'
import {ReactComponent as WarningSVG} from '@assets/SVGs/QontactPoint/WarningSVG.svg'

import QPTurno from './QPTurno';
import { QontactPointInformation, ShiftRecipe, ShiftRecipeWithUserIDs } from '@models/QontactPoint';
import { useNavigate } from 'react-router-dom';
import MultiSelectList, { SelectableItem } from '@components/General/MultiSelectList';
import Image from '@components/General/Image';
import ResultPopup from '@components/General/ResultPopup';
import { ColaboratorInfo } from '@models/Colaborators';


const processName = (name) => {
    const words = name.split(' ');
    const processedWords = words.map(word => {
        const firstLetter = word.charAt(0).toUpperCase();
        const restOfWord = word.slice(1).toLowerCase();
        return firstLetter + restOfWord;
    });
    return processedWords.join(' ');        
}

const renderColaboradorItem = (colaborador: SelectableItem) => (
    <>
        <div style={{width: '24px', height: '24px', marginRight: '10px', display: 'flex'}}>
            <Image src={colaborador.image} alt="Profile Picture" isRound={true} style={{ width: '100%', height: '100%' }} overrideLoading={undefined}/>
        </div>
        <div key={colaborador.id} style={{maxWidth: 'calc(100% - 34px)', fontSize: "14px", color: '#101828'}}>
            {processName(colaborador.name)}
        </div>
    </>
);

interface EditarTurnoProps {
    orgID: string;
    turnoRecipe: ShiftRecipeWithUserIDs;
    colaboradores: ColaboratorInfo[]
    onTurnoModified: (turno: ShiftRecipeWithUserIDs) => void
}

const EditarTurno: React.FC<EditarTurnoProps> = ({orgID, turnoRecipe, colaboradores, onTurnoModified}) => {
    const { showPopup, hidePopup } = usePopup()
    const [loading, setLoading] = useState(false)

    const [turno, setTurno] = useState<ShiftRecipe>(turnoRecipe)
    const [selectedColaboradoresID, setSelectedColaboradoresID] = useState<string[]>(turnoRecipe.userIDs ?? [])
    const [error, setError] = useState("")

    const navigate = useNavigate();

    function normalizeTime(time) {
        const [hour, minute] = time.split(":");
        const normalizedHour = parseInt(hour, 10).toString();
        return `${normalizedHour}:${minute}`;
    }

    const handleValidation = () => {
        if (turno.name.trim() === '' || turno.hourFrom.trim() === '' || turno.hourTo.trim() === '') {
            setError("No pueden haber campos vacios.")
            return false
        }

        setError("")
        return true
    }

    const handleSave = async () => {
        if (!handleValidation()) return
        if (loading) return

        let type = turno.type
        if (!turno.configurationData.weekdays || turno.configurationData.weekdays.length == 7 || turno.configurationData.weekdays.length == 0) {
            type = "daily"
        } else if (turno.configurationData.weekdays.length > 0 && turno.configurationData.weekdays.length < 7) { 
            type = "weekly"
        }
        
        const newTurno: ShiftRecipeWithUserIDs = {
            ...turno,
            hourFrom: normalizeTime(turno.hourFrom),
            hourTo: normalizeTime(turno.hourTo),
            type: type,
            userIDs: selectedColaboradoresID
        }

        setLoading(true)
        try {
            const shiftsService = Application.shared().coreDependencies.shiftsService;
            await shiftsService.updateShiftRecipe(orgID, turno.firestoreRecordId, newTurno);
            
            showPopup(() => <ResultPopup result={"Turno guardado correctamente"} succesful={true} />);
            onTurnoModified(newTurno)
            goBack()
        } catch (error) {
            showPopup(() => <ResultPopup result={"Error al intenter guardar turno..."} succesful={false} />);
            console.error(error)
        }
        setLoading(false)
    }

    const goBack = () => {
        navigate(-1)
    }

    return (
        <div className={styles['main-container']}>
            <div className={styles['nomina-header']}>
                <div className={styles['svg-container']} style={{marginRight: '8px', marginLeft: '15px'}}>
                    <QontactPointSVG/>
                </div>
                <h2 className={styles['title-nomina']}>
                    Editando {turno.name}
                </h2>
            </div>

            <div className={styles['listado-container']}>
                <QPTurno key={turno.firestoreRecordId} colaboradoresID={selectedColaboradoresID} setTurno={setTurno} turno={turno} isEditable={true} isDeleteable={false} onDetailClick={goBack} isItemFromList={false}/>
                <div style={{height: '70%', width: '100%'}}>
                    <MultiSelectList items={colaboradores} itemRenderer={renderColaboradorItem} selectedIds={selectedColaboradoresID} setSelectedIds={setSelectedColaboradoresID}/>
                </div>
            </div>

            {error && 
            <div className={styles['error-container']}>
                <div className={styles['svg-container']} style={{marginRight: '15px'}}>
                    <WarningSVG/>
                </div>
                {error}
            </div>
            }

            <div className={styles['bottom-container']}>
                    <div className={styles['add-buttons-container']}>
                    </div>

                    <div className={styles['buttons-container']}>
                        <div className={`${styles['button']} ${styles['guardar']}`} onClick={handleSave}>
                            {!loading ? 'Guardar'
                            :
                            <div className={styles['no-qontact-points']}>
                                <Loader height="32px" width="32px" />
                            </div>
                            }
                        </div>
                        <div className={`${styles['button']} ${styles['cancelar']}`} onClick={() => !loading && goBack()}>
                            Cancelar
                        </div>
                    </div>
                </div>
        </div>
    )
}

export default EditarTurno
